import '../ReusableComponents/ModulePage.css';
import SectionButtons from '../ReusableComponents/SectionButtons';





import React, { Component } from 'react';
import { can, canSeeRooms } from '../../permissions';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, THIS_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdEvent, MdSecurity, MdOutlineRule, MdReply, MdReport } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import ModalRegras from './ModalRegras';
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import CandidatosSaidas from '../CandidatosVinculados/CandidatosSaidas';
import VideoAIEvents from '../CandidatosVinculados/VideoAIEvents';

import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import AnalisesCandidatos from '../AnalisesCandidatos/AnalisesCandidatos';
import Downloads from '../Downloads/Downloads';
import QuestionariosVinculados from '../QuestionariosVinculados/QuestionariosVinculados';
import Diagramacoes from '../Diagramacoes/Diagramacoes';
import AvaliadoresVinculados from '../AvaliadoresVinculados/AvaliadoresVinculados';
import Entrevista from '../Entrevista/Entrevista';
import ProcessoConfiguracoes from '../ProcessoConfiguracoes/ProcessoConfiguracoes.js';


class ShowProcesso extends Component {

    moduleContent = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            faculdade: {},
            processo: {},
            show_more:false,

            activeTab: 0
        };

    }


    get_processo(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_processo/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, 
                        faculdade: resp.processo.faculdade || {}, 
                        processo: resp.processo
                    });
                }

            } catch (err) {
                this.setState({ 
                    redirect: true,
                    loading_screen: false 
                });
                console.log(err);
            }

        })
            .catch((err) => {
                this.setState({ 
                    redirect: true,
                    loading_screen: false 
                });
                console.log(err);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: 0 });
        this.get_processo(this.props.match.params.id);
    }







    componentDidUpdate(previousProps) {
        if (previousProps.location.search !== this.props.location.search) {
            const tab = Number(new URLSearchParams(this.props.location.search).get('tab') || 0);
            if (tab !== this.state.activeTab) this.setState({ activeTab: tab });
        }
    }

    render() {
        const allowedTabs = ["redacoes", "provas", "provas", "questionarios", "candidatos", "corretores", "fiscais", "candidatos", "candidatos", "avaliadores", "processo_seletivo", "entrevistas"].map(module => !module || can(this.props.user, module));
        const hasOnlineAssessment = this.state.processo.online === true || this.state.processo.online === 1 || this.state.processo.online === '1';
        allowedTabs[6] = allowedTabs[6] && hasOnlineAssessment && !this.state.processo.is_interview;
        allowedTabs[9] = allowedTabs[9] && hasOnlineAssessment;
        allowedTabs[3] = allowedTabs[3] && hasOnlineAssessment;
        allowedTabs[8] = allowedTabs[8] && hasOnlineAssessment;
        allowedTabs[4] = canSeeRooms(this.props.user);
        allowedTabs[11] = allowedTabs[11] && hasOnlineAssessment && !!this.state.processo.is_interview;
        allowedTabs[10] = can(this.props.user, 'processo_seletivo', 'edit');
        const selectedTab = allowedTabs[this.state.activeTab] ? this.state.activeTab : allowedTabs.findIndex(Boolean);
        const sections = [{ value: 0, label: 'Redações', description: 'Consulte as redações e suas correções.', icon: 'redacoes', visible: allowedTabs[0] },
{ value: 1, label: 'Provas', description: 'Gerencie as provas do processo.', icon: 'provas', visible: allowedTabs[1] },
{ value: 2, label: 'Diagramações', description: 'Configure a apresentação das provas.', icon: 'diagramacoes', visible: allowedTabs[2] },
{ value: 3, label: 'Questionários', description: 'Gerencie os questionários do processo.', icon: 'questionarios', visible: allowedTabs[3] },
{ value: 4, label: 'Salas', description: 'Organize as salas e seus participantes.', icon: 'salas', visible: allowedTabs[4] },
{ value: 5, label: 'Corretores Vinculados', description: 'Gerencie os corretores deste processo.', icon: 'corretores', visible: allowedTabs[5] },
{ value: 6, label: 'Fiscais Vinculados', description: 'Gerencie os fiscais deste processo.', icon: 'fiscais', visible: allowedTabs[6] },
{ value: 7, label: 'Candidatos Vinculados', description: 'Consulte os candidatos deste processo.', icon: 'candidatos', visible: allowedTabs[7] },
{ value: 8, label: 'Eventos IA', description: 'Veja as ocorrências detectadas pela IA.', icon: 'eventos', visible: allowedTabs[8] },
{ value: 9, label: 'Avaliadores Vinculados', description: 'Gerencie os avaliadores deste processo.', icon: 'avaliadores', visible: allowedTabs[9] },
{ value: 10, label: 'Configurações', description: 'Ajuste as opções do processo seletivo.', icon: 'configuracoes', visible: allowedTabs[10] },
{ value: 11, label: 'Entrevistas', description: 'Acesse as entrevistas do processo.', icon: 'entrevistas', visible: allowedTabs[11] && !!this.state.processo.is_interview },
{ value: 'reports', label: 'Relatórios', description: 'Visualize os indicadores do processo.', icon: 'relatorios', visible: this.props.user?.empresa?.online_proccess == true }
];
        const selectedSection = sections.find(item => item.value === selectedTab && item.visible !== false);
        if (this.state.loading_screen) return <SkeletonCoursePage />
        
        // Verificar se os dados necessários foram carregados
        if (!this.state.processo) {
            return <SkeletonCoursePage />
        }
        
        return (
          <div className="module-page">
            <div className="card module-card module-identity hidethis">
              <div className="card-body">
                <div className="module-heading">
                  <div className="module-heading-text">
                    <h1>{this.state.processo.name}</h1>
                    {this.state.processo.descricao && <div className="module-description"><TextReadMore element="div" limit={200}>{this.state.processo.descricao}</TextReadMore></div>}
                    {this.state.processo.inicio && this.state.processo.fim && <span className={`module-status ${moment().isAfter(this.state.processo.fim) ? 'is-finished' : moment().isBefore(this.state.processo.inicio) ? 'is-scheduled' : 'is-active'}`}>
                      {moment().isAfter(this.state.processo.fim) ? 'Finalizado' : moment().isBefore(this.state.processo.inicio) ? 'Agendado' : 'Em andamento'}
                    </span>}
                  </div>
                  <div className="module-back hidethis"><DefaultButton bg="secondary" text="Voltar" icon={<RiArrowGoBackLine />} to={`/instituicao/show/${this.state.processo?.faculdade_id || ''}`} /></div>
                </div>
                <div className="module-facts">
                  <div className="module-fact"><span className="module-fact-icon"><MdEvent aria-hidden="true" /></span><div><span>Início</span><strong>{this.state.processo.inicio ? moment(this.state.processo.inicio).format('DD/MM/YYYY HH:mm') : 'Não informado'}</strong></div></div>
                  <div className="module-fact"><span className="module-fact-icon is-orange"><MdEvent aria-hidden="true" /></span><div><span>Encerramento</span><strong>{this.state.processo.fim ? moment(this.state.processo.fim).format('DD/MM/YYYY HH:mm') : 'Não informado'}</strong></div></div>
                  <div className="module-fact"><span className="module-fact-icon is-cyan"><MdSecurity aria-hidden="true" /></span><div><span>Tipo de fiscalização</span><strong>{this.state.processo.online == false ? 'Processo presencial' : ({ all: 'Salvar vídeos e imagens com streaming em tempo real', image: 'Salvar imagens com streaming em tempo real', none: 'Salvar apenas logs, sem streaming' }[this.state.processo.type_fiscalization] || 'Não informado')}</strong></div></div>
                  <button type="button" className="module-fact module-fact-action" onClick={() => this.setState({ show_more: true })}><span className="module-fact-icon is-green"><MdOutlineRule aria-hidden="true" /></span><span><span>Regras</span><strong>Ver regras</strong></span></button>
                </div>
                <ModalRegras showModal={this.state.show_more} setShowModal={e => this.setState({ show_more: e })} processo_name={this.state.processo.name} regras={this.state.processo.regras} />

              </div>
            </div>
            <div className="card module-card module-selector hidethis">
              <div className="card-body">
                <h2 className="module-selector-title hidethis">Escolha um módulo para gerenciar</h2>
                <SectionButtons variant="modules" value={selectedTab} items={sections} onChange={value => {
                      if (value === 'reports') {
                        this.props.history.push({ pathname: `/instituicao/dashboard/${this.state.processo.faculdade_id}`, search: `?processo_id=${this.state.processo.id}` });
                        return;
                      }
                      this.setState({ activeTab: value }, () => {
                        this.moduleContent.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      });
                      const params = new URLSearchParams(this.props.location.search);
                      params.set('tab', value);
                      this.props.history.push({ search: `?${params.toString()}` });
                    }} />
              </div>
            </div>
            <div className="card module-card module-content" ref={this.moduleContent} style={{ scrollMarginTop: 90 }}>
              <div className="card-body">
                {selectedSection && <div className="module-content-heading hidethis">
                  <h2>{selectedSection.label}</h2>
                  <p>{selectedSection.description}</p>
                </div>}
                <TabPanel value={selectedTab} index={0}>
                  {allowedTabs[0] && <Redacoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                  {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                  {allowedTabs[1] && <Provas
                    processo_id={this.state.processo.id}
                    inicio={this.state.processo.inicio}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>

                <TabPanel value={selectedTab} index={2}>
                  {allowedTabs[2] && <Diagramacoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                  />}
                </TabPanel>

                {
                  <TabPanel value={selectedTab} index={3}>
                    {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {/* <Provas processo_id={this.state.processo.id} processo_name={this.state.processo.name} /> */}
                    {allowedTabs[3] && this.props.user?.empresa?.online_proccess == true &&
                      this.props.user.id != undefined &&
                      (this.props.user.role == "region_admin" ||
                        this.props.user.empresa == null ||
                        this.props.user.empresa.hide_questionario == false) && (
                        <QuestionariosVinculados
                          simulado={this.state.processo.simulado}
                          processo_id={this.state.processo.id}
                          processo_name={this.state.processo.name}
                        />
                      )}
                    {(this.props.user?.empresa?.online_proccess == false ||
                      !(
                        this.props.user.role == "region_admin" ||
                        this.props.user.empresa == null ||
                        this.props.user.empresa.hide_questionario == false
                      )) && (
                      <div>
                        <p style={{ textAlign: "center" }}>
                          Módulo não habilitado
                        </p>
                      </div>
                    )}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={4}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[4] && <SalasProcesso
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={5}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[5] && <CorretoresVinculados
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={6}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[6] && !(
                      this.props.user?.empresa?.online_proccess == false ||
                      this.state.processo.online == false
                    ) && (
                      <FiscaisVinculados
                        processo_id={this.state.processo.id}
                        processo_name={this.state.processo.name}
                      />
                    )}
                    {(this.props.user?.empresa?.online_proccess == false ||
                      this.state.processo.online == false) && (
                      <p style={{ textAlign: "center" }}>
                        Módulo não habilitado
                      </p>
                    )}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={7}>
                    {/* <Alunos faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[7] && <CandidatosVinculados
                      online={this.state.processo.online}
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                      faculdade={this.state.faculdade}
                    />}
                  </TabPanel>
                }

                <TabPanel value={selectedTab} index={8}>
                  {allowedTabs[8] && (this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true ? (
                    <VideoAIEvents
                      processo_id={this.state.processo.id}
                    />
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      Módulo não habilitado
                    </p>
                  ))}
                </TabPanel>

                <TabPanel value={selectedTab} index={9}>
                  {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                  {allowedTabs[9] && <AvaliadoresVinculados
                    processo_id={this.state.processo.id}
                    inicio={this.state.processo.inicio}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>

                <TabPanel value={selectedTab} index={10}>
                  {allowedTabs[10] && (this.props.user?.empresa?.plan?.training == true ? <ProcessoConfiguracoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                  />:
                   <p style={{ textAlign: "center" }}>
                        Módulo não habilitado
                      </p>)}
                </TabPanel>

                {this.state.processo.is_interview && (
                  <TabPanel value={selectedTab} index={11}>
                    {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[11] && <Entrevista
                      processo_id={this.state.processo.id}
                      inicio={this.state.processo.inicio}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                )}

                {/* {this.state.processo.online==true && <TabPanel value={selectedTab} index={8}>
                            <CandidatosSaidas processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}

                          {this.state.processo.online==true && <TabPanel value={selectedTab} index={9}>
                            <AnalisesCandidatos processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}


                         {this.state.processo.online==true && <TabPanel value={selectedTab} index={10}>
                            <AnalisesCandidatosObjetos processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}

                         {this.state.processo.online==true && <TabPanel value={selectedTab} index={11}>
                            <Downloads processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>} */}
              </div>
            </div>
          </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,

    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowProcesso);
